// 公共信息
const state = {
  content: {
    // 版权信息
    copyright_info: {},
  },
  // 是否是移动端
  isMobile: false,
};

const mutations = {
  SET_CONTENT(state, payload) {
    state.content = payload;
  },
  SET_DEVICE_TYPE(state, isMobile) {
    state.isMobile = isMobile;
  }
};

const actions = {
  // 动态设置内容
  setContent({ commit }, content) {
    commit('SET_CONTENT', content);
  },
  checkDeviceType({ commit }) {
    const isMobile = window.innerWidth <= 768; // 判断是否是移动设备
    commit('SET_DEVICE_TYPE', isMobile);
  }
};

const getters = {
  isMobile: state => state.isMobile,
};



export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/common/index.js